<template></template>
<script>
import { Base64 } from "js-base64";
import { authService } from "@/services/auth";
import apis from "@/services/apis";

export default {
  data() {
    return {};
  },
  methods: {
    setUserLocalData(userId) {
      if (GLOBAL_ENV_SDKTYPE === "sso") {
        return apis.getSsoUserProfile(userId).then((profile) => {
          // console.log("the profile response " + JSON.stringify(profile));

          if (profile && profile.placeId) {
            let addrObj = {
              address: profile.address,
              mainText: profile.mainText,
              secondaryText: profile.secondaryText,
              placeId: profile.placeId,
              // aptSuiteFloor: responses.aptSuiteFloor
            };
            // update address input
            // 有了就不更新了
            if (!localStorage.getItem("address")) {
              localStorage.setItem(
                "address",
                Base64.encode(JSON.stringify(addrObj))
              );
            }
          } else if (profile) {
            
            localStorage.setItem(
              "lineUserProfile",
              Base64.encode(
                JSON.stringify({
                  liffApp: GLOBAL_ENV_LIFFID, // 為了避免跨provider問題，都要重新auth
                  name: profile.displayName,
                  picture: profile.pictureUrl,
                  phone: profile.phone,
                  localPhone: profile.localPhone,
                })
              )
            );
            console.log("set addr done");
          }
          return profile;
        });
      } else {
        return apis.getUserProfile(userId).then((profile) => {
          // console.log("the profile response " + JSON.stringify(profile));

          if (profile && profile.placeId) {
            let addrObj = {
              address: profile.address,
              mainText: profile.mainText,
              secondaryText: profile.secondaryText,
              placeId: profile.placeId,
              // aptSuiteFloor: responses.aptSuiteFloor
            };
            // update address input
            // 有了就不更新了
            if (!localStorage.getItem("address")) {
              localStorage.setItem(
                "address",
                Base64.encode(JSON.stringify(addrObj))
              );
            }

            localStorage.setItem(
              "lineUserProfile",
              Base64.encode(
                JSON.stringify({
                  liffApp: GLOBAL_ENV_LIFFID, // 為了避免跨provider問題，都要重新auth
                  name: profile.displayName,
                  picture: profile.pictureUrl,
                  phone: profile.phone,
                  localPhone: profile.localPhone,
                })
              )
            );
            // console.log("set addr done");
          }
          return profile;
        });
      }
    },
  },
  mounted() {
    let userId = localStorage.getItem("lineUserId");
    let userProfile = localStorage.getItem("lineUserProfile");
    
    let self = this;

    if (userProfile) {
      let userProfileObj = JSON.parse(Base64.decode(userProfile));
      // console.log('debug the user profile obj ' + JSON.stringify(userProfileObj));
      // console.log('vs ' + GLOBAL_ENV_LIFFID);
      if (
        !userProfileObj.liffApp ||
        userProfileObj.liffApp !== GLOBAL_ENV_LIFFID
      ) {
        userId = userProfile = null;
      }
    }

    let qsStringify = function(obj) {
      return obj
        ? Object.keys(obj)
            .map(function(key) {
              var val = obj[key];

              if (Array.isArray(val)) {
                return val
                  .map(function(val2) {
                    return (
                      encodeURIComponent(key) + "=" + encodeURIComponent(val2)
                    );
                  })
                  .join("&");
              }

              return encodeURIComponent(key) + "=" + encodeURIComponent(val);
            })
            .join("&")
        : "";
    };
    /**
     * Initialize LIFF
     * @param {string} myLiffId The LIFF ID of the selected element
     */
    function initializeLiff(myLiffId) {
      console.log("init the liff id " + myLiffId);
      liff
        .init({
          liffId: myLiffId,
          qcAccountId: self.$router.currentRoute.query.s
        })
        .then(() => {
          if (liff.isLoggedIn()) {
            // let userProfile = localStorage.getItem("lineUserProfile");
            // let userProfileObj = JSON.parse(Base64.decode(userProfile));
            // if (!userProfileObj.liffApp || userProfileObj.liffApp !== GLOBAL_ENV_LIFFID) {
            //   liff.logout();
            // }
            // The user can use an API that requires an access token, such as liff.getProfile().
            // start to use LIFF's api
            const idToken = liff.getDecodedIDToken();
            console.log("idToken", idToken); // print decoded idToken object
            // idToken.email
            // idToken.name

            liff
              .getProfile()
              .then((profile) => {
                if (!profile) {
                  profile = {};
                }

                let userUid = profile.userId;
                if (GLOBAL_ENV_SDKTYPE === "sso") userUid = profile.uuid;

                if (userUid) {
                  self.setUserLocalData(userUid).then((profileDone) => {
                    console.log(
                      "signin done, please retreive related information"
                    );
                    if (profileDone && profileDone.lineUserId) {

                      localStorage.setItem(
                        "lineUserProfile",
                        Base64.encode(
                          JSON.stringify({
                            liffApp: GLOBAL_ENV_LIFFID, // 為了避免跨provider問題，都要重新auth
                            name: profileDone.name,
                            picture: profileDone.picture,
                            phone: profileDone.phone,
                            localPhone: profileDone.localPhone
                          })
                        )
                      );

                      authService.setUserId(userUid);
                    } else {
                      let postFun = apis.postUserProfile;
                      if (GLOBAL_ENV_SDKTYPE === "sso") {
                        postFun = apis.postSsoUserProfile;
                      }
                      postFun(userUid, {
                        name: profile.displayName,
                        picture: profile.pictureUrl,
                        userId: profile.lineUserId,
                        loginType: profile.authProvider
                      }).then((response) => {
                        console.log(
                          "add user done " + JSON.stringify(response)
                        );
                      });
                      console.info('we miss here ' + JSON.stringify(profile));
                      localStorage.setItem(
                        "lineUserProfile",
                        Base64.encode(
                          JSON.stringify({
                            liffApp: GLOBAL_ENV_LIFFID, // 為了避免跨provider問題，都要重新auth
                            name: profile.displayName,
                            picture: profile.pictureUrl,
                            phone: profile.phone
                          })
                        )
                      );
                      authService.setUserId(userUid);
                    }
                  });
                  localStorage.setItem("lineUserId", profile.userId);
                  localStorage.setItem("qcsso:uuid", profile.uuid);

                  // oauth的相關參數就不要一直帶了
                  // console.log("redirect again gogogo");
                  delete self.$router.currentRoute.query["sso_clienttoken"];
                  // 接下來這個步驟，會拿掉其他參數只留下p跟s（為了避免liff有太多敏感連結)
                  // console.log('the route ' + JSON.stringify(self.$router.currentRoute.query));
                  // let forwardQ = {};
                  // let omit = {};
                  // for (let key in self.$router.currentRoute.query) {
                  //   if (!omit[key])
                  //     forwardQ[key] = self.$router.currentRoute.query[key];
                  // }
                  // self.$router.push({
                  //   path: location.pathname,
                  //   query: forwardQ
                  //   // query: {
                  //   //   p: self.$router.currentRoute.query.p,
                  //   //   s: self.$router.currentRoute.query.s,
                  //   // },
                  // });
                } else {
                  console.log("cannot get the liff token ");
                }
              })
              .catch((e) => {
                console.error("liff get profile failed " + e.stack);
              });

            // const context = liff.getContext();
            // console.log("context", context);

            // if (context && context.userId) {
            //   // apis.getUserProfile(context.userId);
            //   self.setUserLocalData(context.userId).then((profileDone) => {
            //     console.log("signin done, please retreive related information");
            //     if (profileDone && profileDone.lineUserId) {
            //       localStorage.setItem(
            //         "lineUserProfile",
            //         Base64.encode(
            //           JSON.stringify({
            //             liffApp: GLOBAL_ENV_LIFFID, // 為了避免跨provider問題，都要重新auth
            //             name: profileDone.name,
            //             picture: profileDone.picture,
            //           })
            //         )
            //       );
            //       authService.setUserId(context.userId);
            //     } else {
            //       liff
            //         .getProfile()
            //         .then((profile) => {
            //           console.log(
            //             "the liff profile is " + JSON.stringify(profile)
            //           );
            //           apis
            //             .postUserProfile(context.userId, {
            //               name: profile.displayName,
            //               picture: profile.pictureUrl,
            //             })
            //             .then((response) => {
            //               console.log(
            //                 "add user done " + JSON.stringify(response)
            //               );
            //             });
            //           localStorage.setItem(
            //             "lineUserProfile",
            //             Base64.encode(
            //               JSON.stringify({
            //                 liffApp: GLOBAL_ENV_LIFFID, // 為了避免跨provider問題，都要重新auth
            //                 name: profile.displayName,
            //                 picture: profile.pictureUrl,
            //               })
            //             )
            //           );
            //           authService.setUserId(context.userId);
            //         })
            //         .catch((e) => {
            //           console.error("liff get profile failed " + e.stack);
            //         });
            //     }
            //   });
            //   localStorage.setItem("lineUserId", context.userId);
            //   localStorage.setItem("qcsso:uuid", context.uuid);

            //   // oauth的相關參數就不要一直帶了
            //   console.log("redirect again gogogo");
            //   self.$router.push({
            //     path: "/",
            //     query: {
            //       p: self.$router.currentRoute.query.p,
            //       s: self.$router.currentRoute.query.s,
            //     },
            //   });
            //   // http://localhost:4200/?p=gofoodie&code=t7WA1Xli5TrtrH8xL1zV&liffClientId=1653927686&state=lL3Wx4glZdMk&liffRedirectUri=https%3A%2F%2Flocalhost%3A4200%3Fp%3Dgofoodie
            // } else {
            //   // 有時候似乎isLoggedIn但是idToken卻是null (Provider切換？)
            //   console.log("cannot get the liff token ");
            // }
          } else {
            // 因為path行為會怪怪只好hardcode (有時候self.$router.currentRoute.path 拿不到path...)
            // 這個hardcode解決不了shop_id, 要再確認怎辦...
            // console.log('the tab tab auth ' + GLOBAL_TABS);
            console.log(" ----- ");
            console.log(
              "not signin ... the portal key is " +
                JSON.stringify(self.$router.currentRoute.query)
            );
            // 好像切換provider會導致一些問題
            console.log("the location = " + "https://" +
                  location.host +
                  location.pathname +
                  "?" +
                  qsStringify(self.$router.currentRoute.query));
            // if (self.$router.currentRoute.query.a === "sso") {
            if (GLOBAL_ENV_SDKTYPE === "sso") {
              liff.login({
                redirectUri:
                  "https://" +
                  location.host +
                  location.pathname +
                  "?" +
                  qsStringify(self.$router.currentRoute.query),
              });
            } else {
              // 這個做法，電腦版本的liff會有問題?
              
              liff.login({
                redirectUri:
                  "https://" +
                  location.host +
                  location.pathname + // 為什麼liff舊版不帶？
                  "?" +
                  qsStringify(self.$router.currentRoute.query),
              });
            }

            // if (GLOBAL_TABS === "os") {
            //   liff.login({
            //     redirectUri:
            //       "https://" +
            //       location.host +
            //       "/orders?" +
            //       qsStringify(self.$router.currentRoute.query),
            //   });
            // // } else if (GLOBAL_TABS === "tdos") {
            // //   liff.login({
            // //     redirectUri:
            // //       "https://" +
            // //       location.host +
            // //       "/togo?" +
            // //       qsStringify(self.$router.currentRoute.query),
            // //   });
            // } else {
            //   liff.login({
            //     redirectUri:
            //       "https://" +
            //       location.host +
            //       "?" +
            //       qsStringify(self.$router.currentRoute.query),
            //   });
            // }

            // liff.login({ redirectUri: location.protocol + location.host });
          }
        })
        .catch((err) => {
          console.log(err.stack);
          // document.getElementById("liffAppContent").classList.add('hidden');
          // document.getElementById("liffInitErrorMessage").classList.remove('hidden');
        });
    }

    if (!userId || !userProfile) {
      initializeLiff(GLOBAL_ENV_LIFFID);
    } else {
      if (liff.isInClient()) {
        liff
          .init({
            liffId: GLOBAL_ENV_LIFFID,
            qcAccountId: self.$router.currentRoute.query.s
          })
          .then(() => {
            authService.setUserId(userId);
          });
      } else {
        authService.setUserId(userId);
      }
    }
  },
};
</script>
